import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWarningOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M12 1c-.624 0-1.237.17-1.774.493-.535.32-.976.78-1.278 1.332L.322 17.972a1.089 1.089 0 0 0-.065.136 3.615 3.615 0 0 0 .29 3.248c.299.479.706.877 1.188 1.163a3.45 3.45 0 0 0 1.58.48c.041.002.082.001.122-.001l.066.002H20.53c.57-.004 1.13-.15 1.632-.425.502-.276.93-.672 1.248-1.154a3.614 3.614 0 0 0 .335-3.312 1.09 1.09 0 0 0-.066-.137L15.053 2.825a3.529 3.529 0 0 0-1.277-1.332A3.449 3.449 0 0 0 12 1ZM3.504 20.835c-.022 0-.044 0-.067.002h-.011a1.351 1.351 0 0 1-.619-.188 1.379 1.379 0 0 1-.465-.456 1.408 1.408 0 0 1-.136-1.21l8.589-15.081.01-.019a1.38 1.38 0 0 1 .502-.525 1.35 1.35 0 0 1 1.39 0c.21.126.383.308.501.525l.01.019 8.589 15.08a1.417 1.417 0 0 1-.154 1.235 1.375 1.375 0 0 1-.488.451 1.348 1.348 0 0 1-.636.167H3.503Zm9.573-11.29c0-.598-.476-1.082-1.063-1.082-.588 0-1.064.484-1.064 1.082v2.475c0 .598.476 1.082 1.064 1.082.587 0 1.063-.485 1.063-1.082V9.545Zm0 7.423c0-.597-.476-1.082-1.063-1.082-.588 0-1.064.485-1.064 1.082v.013c0 .598.476 1.082 1.064 1.082.587 0 1.063-.484 1.063-1.082v-.013Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWarningOutline);
export default ForwardRef;
